import React from "react";
import styles from "./CarouselCards.module.scss";
const CarouselCards = ({ title, description, bgImage }) => {
  return (
    <div className={styles.Carousel}>
      <div className={styles.Carousel_title}>{title}</div>
      <div className={styles.Carousel_description}>{description}</div>
    </div>
  );
};

export default CarouselCards;
